export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6288.f88e0b95.jpg";